import { Reveal, Eyebrow } from "./Reveal";

export default function PageHero({ eyebrow, title, sub }) {
  return (
    <section className="relative overflow-hidden bg-cream grain pt-32 pb-16 md:pt-40 md:pb-20">
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-sand/40 blur-2xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -left-16 bottom-0 h-56 w-56 rounded-full bg-teal/10 blur-2xl"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="mt-4 max-w-3xl font-serif text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.1] text-espresso">
            {title}
          </h1>
          {sub && (
            <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-espresso/75">{sub}</p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
